import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationTemplateParameterHttpResponse, INotificationTemplateParameterInfoHttpResponse, NotificationTemplateParameter, NotificationTemplateParameterInfo } from '@app/models/notification-settings';
import { map, Observable } from 'rxjs';

const HttpServiceMethods = {
  NotificationTemplateParameter: 'NotificationTemplateParameter',
  GetNotificationTemplateParameterList: 'NotificationTemplateParameter/GetNotificationTemplateParameterList'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationTemplateParametersService {

  constructor(private httpService: HttpCallService) { }

  public list(notificationRuleId: number): Observable<NotificationTemplateParameterInfo[]> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.GetNotificationTemplateParameterList}/${notificationRuleId}`)
      .pipe(
        map((res) => res.map((item: INotificationTemplateParameterInfoHttpResponse) => NotificationTemplateParameterInfo.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationTemplateParameter> {
    return this.httpService
      .callService(HttpMethodType.GET, `${HttpServiceMethods.NotificationTemplateParameter}/${id}`)
      .pipe(map((item: INotificationTemplateParameterHttpResponse) => NotificationTemplateParameter.adapt(item)));
  }

  public add(notificationRuleParameter: NotificationTemplateParameter) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationTemplateParameter,
      notificationRuleParameter
    );
  }

  public update(notificationRuleParameter: NotificationTemplateParameter) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationTemplateParameter,
      notificationRuleParameter
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      `${HttpServiceMethods.NotificationTemplateParameter}/${id}`
    );
  }
}
